import type { AccountSubscription } from '@frameio/graphql-client/generated';

export const getIsArchivalStorageIncluded = (
  addOns?: AccountSubscription['addOns']
): boolean =>
  addOns?.some((addOn) => addOn.modifier === 'archived_storage_limit') ?? false;
